import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "modal-mask" }
const _hoisted_2 = { class: "modal request-modal" }
const _hoisted_3 = { class: "subtitle" }
const _hoisted_4 = { class: "message-box" }
const _hoisted_5 = { class: "modal-actions" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["disabled"]

import { ref, computed } from 'vue';
import axios from '@/axiosInstance';
import { useToast } from 'vue-toast-notification';


export default /*@__PURE__*/_defineComponent({
  __name: 'PermissionRequestModal',
  props: {
    deviceId: {},
    deviceName: {},
    permissionType: {}
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;
const toast = useToast();

const message = ref("");
const loading = ref(false);

const permissionLabel = computed(() => {
    switch (props.permissionType) {
        case 'change_status': return 'modificare lo stato';
        case 'change_mode': return 'cambiare modalità (statico/dinamico)';
        case 'change_thresholds': return 'modificare le soglie';
        default: return 'effettuare questa azione';
    }
});

async function sendRequest() {
  loading.value = true;
  try {
    await axios.post(`/devices/${props.deviceId}/request-permission`, {
        permissionType: props.permissionType,
        message: message.value
    });
    
    toast.success("Richiesta inviata all'amministratore", { position: 'top-right', duration: 3000 });
    emit('close');
  } catch (e: any) {
    console.error(e);
    
    // Handle cooldown error (409 Conflict)
    if (e.response?.status === 409) {
        // Extract message from various possible response structures
        let cooldownMsg = "Hai già inviato una richiesta recentemente. Riprova più tardi.";
        
        const responseData = e.response?.data;
        if (typeof responseData === 'string') {
            cooldownMsg = responseData;
        } else if (responseData?.details) {
            cooldownMsg = responseData.details;
        } else if (responseData?.message) {
            cooldownMsg = responseData.message;
        } else if (responseData?.error) {
            cooldownMsg = responseData.error;
        }
        
        toast.warning(cooldownMsg, { position: 'top-right', duration: 5000 });
        emit('close'); // Close modal after showing cooldown message
    } else {
        // Generic error
        const errorMsg = e.response?.data?.message || e.response?.data?.details || "Errore nell'invio della richiesta";
        toast.error(errorMsg, { position: 'top-right', duration: 4000 });
    }
  } finally {
    loading.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[7] || (_cache[7] = _createElementVNode("h3", null, "Richiedi Accesso", -1)),
      _createElementVNode("p", _hoisted_3, [
        _cache[2] || (_cache[2] = _createTextVNode(" Non hai i permessi per ", -1)),
        _createElementVNode("strong", null, _toDisplayString(permissionLabel.value), 1),
        _cache[3] || (_cache[3] = _createTextVNode(" su questo dispositivo. ", -1)),
        _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
        _cache[5] || (_cache[5] = _createTextVNode(" Puoi inviare una richiesta all'amministratore. ", -1))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[6] || (_cache[6] = _createElementVNode("label", null, "Messaggio (opzionale)", -1)),
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((message).value = $event)),
          placeholder: "Es. Ho bisogno di modificare lo stato per manutenzione...",
          rows: "3"
        }, null, 512), [
          [_vModelText, message.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          disabled: loading.value,
          class: "send-btn",
          onClick: sendRequest
        }, [
          (loading.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Invio..."))
            : (_openBlock(), _createElementBlock("span", _hoisted_8, "Invia richiesta"))
        ], 8, _hoisted_6),
        _createElementVNode("button", {
          disabled: loading.value,
          class: "cancel-btn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
        }, " Annulla ", 8, _hoisted_9)
      ])
    ])
  ]))
}
}

})